import { convertGenderList } from '../../utils/converters/convertListWithLocalization';
import { PROFILE_FIELDS } from '../../constants/strings';
import { SPACE } from '../../constants/chars';
import {
  convertDateToAPIFormat,
  convertDateToUIFormat,
} from '../../utils/converters/dateConverters';

export function getGeneralInfoFields({
  username,
  aliasName,
  userOrganizations = [],
  providerRole,
}) {
  return formatMessage => [
    {
      title: formatMessage(PROFILE_FIELDS.listTitles.general),
      fields: [
        {
          name: formatMessage(PROFILE_FIELDS.fieldNames.username),
          value: username,
          fieldName: 'username',
        },
        {
          name: formatMessage(PROFILE_FIELDS.fieldNames.aliasName),
          value: aliasName,
          fieldName: 'aliasName',
        },
        {
          name: formatMessage(PROFILE_FIELDS.fieldNames.organizations),
          value: userOrganizations.join(', '),
        },
        {
          name: formatMessage(PROFILE_FIELDS.fieldNames.role),
          value: providerRole,
        },
      ],
    },
  ];
}

export function getPersonalInfoFields(
  {
    bio,
    healthInterests = [],
    firstName,
    lastName,
    gender,
    dob,
    language,
    languages,
  },
  rawGenderList,
  languagesList,
) {
  return formatMessage => [
    {
      title: formatMessage(PROFILE_FIELDS.listTitles.personal),
      fields: [
        {
          name: formatMessage(PROFILE_FIELDS.fieldNames.bio),
          value: bio,
        },
        {
          name: formatMessage(PROFILE_FIELDS.fieldNames.healthInterests),
          value: healthInterests.join(', '),
        },
        [
          {
            name: formatMessage(PROFILE_FIELDS.fieldNames.firstName),
            value: firstName,
          },
          {
            name: formatMessage(PROFILE_FIELDS.fieldNames.lastName),
            value: lastName,
          },
        ],
        [
          {
            name: formatMessage(PROFILE_FIELDS.fieldNames.gender),
            value: gender,
            type: 'select',
            options: convertGenderList(rawGenderList, formatMessage),
          },
          {
            name: formatMessage(PROFILE_FIELDS.fieldNames.age),
            value: convertDateToUIFormat(dob, formatMessage),
            fieldName: 'age',
            type: 'date',
            converters: {
              fromView: value => convertDateToAPIFormat(value, formatMessage),
            },
          },
        ].filter(({ value }) => Boolean(value)),
        {
          name: formatMessage(PROFILE_FIELDS.fieldNames.prefLanguage),
          value: language,
          type: 'select',
          options: languagesList,
          fieldName: 'language',
        },
        {
          name: formatMessage(PROFILE_FIELDS.fieldNames.languages),
          value: languages,
          type: 'select',
          multi: true,
          options: languagesList,
          transformValueFromOptions: true,
          fieldName: 'languages',
        },
      ],
    },
  ];
}

export function getAddressInfoFields({ city, state, postalCode, country }) {
  return formatMessage => [
    {
      title: formatMessage(PROFILE_FIELDS.listTitles.address),
      fields: [
        {
          name: formatMessage(PROFILE_FIELDS.listTitles.address),
          value: [city, state, postalCode, country].filter(Boolean).join(', '),
        },
      ],
    },
  ];
}

export function getPatientFieldSet({ allergies, medicine, healthGoals, mrns }) {
  return formatMessage => [
    {
      columns: true,
      title: formatMessage(PROFILE_FIELDS.listTitles.health),
      fields: [
        {
          name: formatMessage(PROFILE_FIELDS.fieldNames.allergies),
          value: allergies,
          fieldName: 'allergies',
        },
        {
          name: formatMessage(PROFILE_FIELDS.fieldNames.medicine),
          value: medicine,
          fieldName: 'medicine',
        },
        {
          name: formatMessage(PROFILE_FIELDS.fieldNames.healthGoals),
          value: healthGoals,
          fieldName: 'healthGoals',
        },
        ...(mrns
          ? {
              name: formatMessage(PROFILE_FIELDS.listTitles.mrns),
              value: mrns
                .map(({ localUid }) => localUid)
                .filter(localUid => Boolean(localUid))
                .join(', '),
            }
          : []),
      ],
    },
  ];
}

export function getProviderFieldSet({
  practiceAddress1,
  practiceAddress2,
  practiceCity,
  practiceState,
  practiceZip,
  officePhone,
  country,
}) {
  return formatMessage => [
    {
      columns: true,
      title: formatMessage(PROFILE_FIELDS.listTitles.prof),
      fields: [
        {
          name: formatMessage(
            PROFILE_FIELDS.fieldNames.primaryPracticeAddress1,
          ),
          value: practiceAddress1,
          fieldName: 'practiceAddress1',
          maxLength: 50,
        },
        {
          name: formatMessage(
            PROFILE_FIELDS.fieldNames.primaryPracticeAddress2,
          ),
          value: practiceAddress2,
          fieldName: 'practiceAddress2',
          maxLength: 50,
        },
        {
          name: formatMessage(PROFILE_FIELDS.fieldNames.primaryPracticeCity),
          value: practiceCity,
          fieldName: 'practiceCity',
          maxLength: 50,
        },
        {
          name: formatMessage(PROFILE_FIELDS.fieldNames.primaryPracticeState),
          value: practiceState,
          fieldName: 'practiceState',
          separator: SPACE,
          maxLength: 20,
        },
        {
          name: formatMessage(PROFILE_FIELDS.fieldNames.postalCode),
          value: practiceZip,
          fieldName: 'practiceZip',
          maxLength: 20,
        },
        {
          name: formatMessage(PROFILE_FIELDS.fieldNames.primaryPracticeCountry),
          value: country,
          fieldName: 'practiceCountry',
          maxLength: 50,
        },
        {
          name: formatMessage(PROFILE_FIELDS.fieldNames.officePhone),
          value: officePhone,
          fieldName: 'officePhone',
          maxLength: 50,
        },
      ],
    },
  ];
}



// WEBPACK FOOTER //
// ./src/components/PublicProfile/profileFieldSet.js